import React, { useState } from 'react';
import { Download, FileText, Package } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { toast } from 'sonner';

const CatalogSection = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = () => {
    setIsDownloading(true);
    
    // Download the actual PDF catalog
    setTimeout(() => {
      const catalogUrl = 'https://customer-assets.emergentagent.com/job_rk-rotoarc-preview/artifacts/x9gk5zoi_ROTOARC%20CATALOUGE%20%282%29.pdf';
      
      // Create a temporary link and trigger download
      const link = document.createElement('a');
      link.href = catalogUrl;
      link.download = 'RK-ROTOARC-Product-Catalog-2025.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      toast.success('Catalog Download Started', {
        description: 'Your product catalog is being downloaded...'
      });
      
      setIsDownloading(false);
    }, 500);
  };

  return (
    <section className="py-20 bg-zinc-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle, rgba(234, 88, 12, 0.3) 1px, transparent 1px)`,
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 relative z-10">
        <Card className="bg-gradient-to-br from-zinc-800/80 to-zinc-900/80 backdrop-blur-sm border-zinc-700 overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl"></div>
          
          <CardContent className="p-8 md:p-12 relative z-10">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Icon Section */}
              <div className="flex-shrink-0">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-gradient-to-br from-orange-600 to-orange-700 flex items-center justify-center shadow-lg shadow-orange-600/30">
                  <FileText className="w-12 h-12 md:w-16 md:h-16 text-white" />
                </div>
              </div>

              {/* Content Section */}
              <div className="flex-1 text-center md:text-left">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                  Download Our <span className="text-orange-500">Product Catalog</span>
                </h2>
                <p className="text-zinc-400 text-lg mb-6">
                  Get complete specifications, technical details, and pricing information for all our welding equipment and accessories.
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-4 mb-6 justify-center md:justify-start">
                  <div className="flex items-center gap-2 text-sm text-zinc-300">
                    <Package className="w-4 h-4 text-orange-500" />
                    <span>50+ Products</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-zinc-300">
                    <FileText className="w-4 h-4 text-orange-500" />
                    <span>Full Specifications</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-zinc-300">
                    <Download className="w-4 h-4 text-orange-500" />
                    <span>PDF Format</span>
                  </div>
                </div>

                <Button 
                  size="lg"
                  onClick={handleDownload}
                  disabled={isDownloading}
                  className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg font-semibold shadow-lg shadow-orange-600/20 hover:shadow-orange-600/40 transition-all duration-300"
                >
                  <Download className="mr-2 w-5 h-5" />
                  {isDownloading ? 'Preparing Download...' : 'Download Catalog'}
                </Button>

                <p className="text-zinc-500 text-xs mt-4">
                  Free download • No registration required • Updated 2025
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default CatalogSection;